
import { Options, Vue } from 'vue-class-component'
import parabillard from '@/components/Frontend/parabillard/index.vue'

@Options({
  components: {
    parabillard
  }
})

export default class Parabillard extends Vue {}
